import { DocProperty } from 'typescript-openapi-router';

export class Identity {
  @DocProperty({
    type: 'string',
    isRequired: true,
  })
  principalId: string;
}
